import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchOperationJourney, deleteOperationJourney, fetchIndustries, addOperationJourney, updateOperationJourney } from '../services/useOperationJourney';
import { toast } from 'react-toastify';

export const useFetchOperationJourney = (industriesType, filteredData) => {
    return useQuery({
        queryKey: ['operationJourney', { industriesType, filteredData }],
        queryFn: fetchOperationJourney,
        cacheTime: 5 * 60 * 1000,
        staleTime: 0, 
    });
};
export const useFetchIndustries = () => {
    return useQuery({
        queryKey: ['industries'],
        queryFn: fetchIndustries,
        cacheTime: 5 * 60 * 1000,
        staleTime: 0,
    });
};
export const useAddOperationJourney = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addOperationJourney,
        onSuccess: () => {
            toast.success('Operation Journey added successfully.');
            queryClient.invalidateQueries(['operationJourney']); 
        },
        onError: () => {
            toast.error('Error adding operation Journey.');
        },
    });
};

export const useUpdateOperationJourney = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }) => updateOperationJourney(id, data),
        onSuccess: () => {
            toast.success('Operation Journey updated successfully.');
            queryClient.invalidateQueries(['operationJourney']); 
        },
        onError: () => {
            toast.error('Error updating operation Journey.');
        },
    });
};

export const useDeleteOperationJourney = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteOperationJourney,
        onSuccess: (response) => {
            toast.success(response?.data?.message || 'Operation Journey deleted successfully.');
            queryClient.invalidateQueries(['operationJourney']);
        },
        onError: () => {
            toast.error('Error deleting operation Journey.');
        },
    });
};
